import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import LegalbirdCall from "../../TwilioVoice/LegalbirdCall";
import { useCall } from "../../../provider/CallProvider";
import CaseCallDialer from "../../TwilioVoice/CaseCallDialer";
import CaseCallDocumentation from "../../PhoneCalls/CaseCallDocumentation";

type CallModalProps = {
  open: boolean;
  handleClose: () => void;
};

function CallModal({ open, handleClose }: CallModalProps) {
  const { call, isConnecting, calendlyEvent, callProduct, caseCallToDocumentId } = useCall();
  if (!callProduct) {
    return null;
  }
  return (
    <LegalbirdIoModal handleClose={handleClose} open={open} title={caseCallToDocumentId ? "Telefonat dokumentieren" : "Anrufen"}
      disableBackdropClick hideCloseButton cancelButtonLabel={call || isConnecting ? "Minimieren" : "Schließen"}
      keepMounted={call !== null || isConnecting}>
      {calendlyEvent && <LegalbirdCall product={callProduct} calendlyEvent={calendlyEvent} />}
      {!calendlyEvent && !caseCallToDocumentId && <CaseCallDialer key={callProduct.id} />}
      {caseCallToDocumentId && <CaseCallDocumentation key={caseCallToDocumentId} phoneCallId={caseCallToDocumentId} onClose={handleClose} />}
    </LegalbirdIoModal>
  );
}

export default CallModal;
